export default {
  summary_one: '{{count}} item foi removido · não disponível para a sua hora de levantamento',
  summary_other: '{{count}} itens foram removidos · não disponíveis para a sua hora de levantamento',
  reason: 'Apenas encomendável {{schedule}} — o seu levantamento é às {{time}}.',
  change_pickup_time: 'Alterar hora de levantamento',
  dismiss: 'Dispensar',
};
